/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_4_2Inputs */



/**
* | output |
* | --- |
* | "False positives (incorrectly blocked legitimate requests)" |
*
* @param {Guardrails_Section_4_2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_4_2 = /** @type {((inputs?: Guardrails_Section_4_2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_4_2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("False Positives (fälschlicherweise blockierte legitime Anfragen)")
	return /** @type {LocalizedString} */ ("False positives (incorrectly blocked legitimate requests)")
});